var version = {
    "name":      "dativery",
    "buildDateCode": "20260415-163048",
    "buildDate": "Wed Apr 15 2026 16:30:48 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260415-163048",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;